import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';

interface OpenTicketsCardProps {
  value: number;
}

const OpenTicketsCard: React.FC<OpenTicketsCardProps> = ({ value }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1, minWidth: { xs: '100%', sm: 'calc(50% - 8px)', lg: 'auto' } }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="body2" sx={{ color: '#64748b', mb: 1 }}>
              Open Tickets
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e293b' }}>
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: '#f59e0b15',
              borderRadius: '50%',
              p: 1,
              display: 'flex',
            }}
          >
            <TrendingUpIcon sx={{ color: '#f59e0b' }} />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default OpenTicketsCard;
